/**
 * Written as a hook for symmetry. As you can see, it isn't. We're also being
 * opinionated and not allowing the developer to specify the country. They
 * shouldn't care.
 */

import { getCountryFromUrl } from "../";
import { CustomerResources } from "../../models";

import * as resourceData from "./data.json";

const getCustomerResources = (): CustomerResources =>
  resourceData["country"][getCountryFromUrl()];

export default getCustomerResources;
